import axiosInstance from "../../../api/axiosInstance";

const buildParams = (payload) => ({
  class_room_id: payload.classRoomId,
  student_id: payload.studentId ?? null,
});

export default {
  namespaced: true,
  state: {
    selCompetencies: {},
    creativeModeData: {},
    questCompletionData: {},
    assessmentAnswers: {},
    selCompetenciesLoading: false,
    creativeModeDataLoading: false,
    questCompletionDataLoading: false,
    assessmentAnswersLoading: false,
    episodeGraphData: {},
    dialogueChoicesData: [],
  },
  actions: {
    async loadSelCompetencies(
      { commit },
      { studentId = null, classRoomId }
    ) {
      commit("setSelCompetenciesLoading", true);
      try {
        const response = await axiosInstance.get(
          "/dashboard/sel_competencies",
          { params: buildParams({ studentId, classRoomId }) }
        );
        commit("setSelCompetencies", response.data.sel_competencies);
      } finally {
        commit("setSelCompetenciesLoading", false);
      }
    },
    async loadCreativeModeData(
      { commit },
      { studentId = null, classRoomId }
    ) {
      commit("setCreativeModeDataLoading", true);
      try {
        const response = await axiosInstance.get(
          "/dashboard/creative_mode_data",
          { params: buildParams({ studentId, classRoomId }) }
        );
        commit("setCreativeModeData", response.data.creative_mode_data);
      } finally {
        commit("setCreativeModeDataLoading", false);
      }
    },
    async loadQuestCompletionData(
      { commit },
      { studentId = null, classRoomId }
    ) {
      commit("setQuestCompletionDataLoading", true);
      try {
        const response = await axiosInstance.get(
          "/dashboard/quest_completion_data",
          { params: buildParams({ studentId, classRoomId }) }
        );
        commit("setQuestCompletionData", response.data.quest_completion_data);
      } finally {
        commit("setQuestCompletionDataLoading", false);
      }
    },
    async loadAssessmentAnswers(
      { commit },
      { studentId = null, classRoomId }
    ) {
      commit("setAssessmentAnswersLoading", true);
      try {
        const response = await axiosInstance.get(
          "/dashboard/assessment_answers",
          { params: buildParams({ studentId, classRoomId }) }
        );
        commit("setAssessmentAnswers", response.data.assessment_answers);
      } finally {
        commit("setAssessmentAnswersLoading", false);
      }
    },
    loadDashboardSections(
      { dispatch },
      { studentId = null, classRoomId }
    ) {
      const payload = { studentId, classRoomId };
      dispatch("loadSelCompetencies", payload, { root: false });
      dispatch("loadCreativeModeData", payload, { root: false });
      dispatch("loadQuestCompletionData", payload, { root: false });
      dispatch("loadAssessmentAnswers", payload, { root: false });
    },
    async loadEpisodeGraphData(
      { commit },
      { episodeNumber, classRoomId, studentId = null }
    ) {
      const response = await axiosInstance.get(
        "/dashboard/episode_graph_data",
        {
          params: {
            episode_number: episodeNumber,
            class_room_id: classRoomId,
            student_id: studentId,
          },
        }
      );
      commit("setEpisodeGraphData", response.data.episode_graph_data);
    },
    async loadDialogueChoicesData(
      { commit },
      { classRoomId, studentId = null }
    ) {
      const response = await axiosInstance.get(
        "/dashboard/dialogue_choices_data",
        {
          params: {
            class_room_id: classRoomId,
            student_id: studentId,
          },
        }
      );
      commit("setDialogueChoicesData", response.data.dialogue_choices_data);
    },
  },
  mutations: {
    setSelCompetencies(state, data) {
      state.selCompetencies = data ?? {};
    },
    setCreativeModeData(state, data) {
      state.creativeModeData = data ?? {};
    },
    setQuestCompletionData(state, data) {
      state.questCompletionData = data ?? {};
    },
    setAssessmentAnswers(state, data) {
      state.assessmentAnswers = data ?? {};
    },
    setSelCompetenciesLoading(state, value) {
      state.selCompetenciesLoading = value;
    },
    setCreativeModeDataLoading(state, value) {
      state.creativeModeDataLoading = value;
    },
    setQuestCompletionDataLoading(state, value) {
      state.questCompletionDataLoading = value;
    },
    setAssessmentAnswersLoading(state, value) {
      state.assessmentAnswersLoading = value;
    },
    setEpisodeGraphData(state, data) {
      state.episodeGraphData = data;
    },
    setDialogueChoicesData(state, data) {
      state.dialogueChoicesData = data;
    },
  },
  getters: {
    dashboardData: (state) => ({
      sel_competencies: state.selCompetencies,
      creative_mode_data: state.creativeModeData,
      quest_completion_data: state.questCompletionData,
      assessment_answers: state.assessmentAnswers,
    }),
    selCompetenciesLoading: (state) => state.selCompetenciesLoading,
    creativeModeDataLoading: (state) => state.creativeModeDataLoading,
    questCompletionDataLoading: (state) => state.questCompletionDataLoading,
    assessmentAnswersLoading: (state) => state.assessmentAnswersLoading,
    episodeGraphData: (state) => state.episodeGraphData,
    dialogueChoicesData: (state) => state.dialogueChoicesData,
  },
};
